<template>
      <a-col>
        <div class="provisioning_btn_container">
            <a-button block class="green_bg step_btn" size="large" @click="handleFieldValue(infoStateObj)">開通裝置</a-button>
        </div>
      </a-col>
</template>

<script>
    import { bus } from "../../main";
    export default {
        props: {
        
        },
        data() {
            return {
                // 預設初始狀態名字、車號、手機號碼都是空的，且名字也無特殊字元
                isNameEmpty: true,
                hasNameIllegalCharaters: false,
                isCarNoInvaild: true,
                isPhoneInvaild: true,
            }
        },
        created() {
            bus.$on("passProvisioningInfo", data => {
                console.log('data', data);
                this.checkFieldVaild(data);
            });          
        },
        methods: {
            checkFieldVaild(info) {
                sessionStorage.setItem('name', info.name);
                sessionStorage.setItem('carNo', info.carNo);
                sessionStorage.setItem('phone', info.phone);
                for (const key in info) {
                    if (Object.hasOwnProperty.call(info, key)) {
                        let carNoResult = false;
                        let phoneResult = false;
                        switch (key) {
                            case 'name':
                                // 檢查名字是否空白
                                this.isNameEmpty = !info[key].trim() ? true : false;
                                // 名字有輸入時，檢查名字是否有不合法的特殊符號
                                if (!this.isNameEmpty) this.hasNameIllegalCharaters = /[!@#$%^&*|+=~]/g.test(info[key].trim());
                                
                                break;
                            case 'carNo':
                                // 檢查車號是否空白
                                if (!info[key].trim()) carNoResult = true;
                                // 檢查車號是否有除了數字、英文、'-'以外的字
                                else if (/[^A-Za-z0-9-]/g.test(info[key].trim())) carNoResult = true;
                                // 檢查車號是否只含有一個'-'
                                else if (info[key].trim().match(/[-]/g).length !== 1) carNoResult = true;

                                this.isCarNoInvaild = carNoResult;
                                break;
                            case 'phone':
                                // 檢查手機號碼是否空白
                                if(!info[key]) {
                                    phoneResult = true;
                                }
                                // 把'-'拿掉後，檢查手機號碼長度是否超過限制
                                else if (info[key].replace(/-/g,'').length !== 10) {
                                    phoneResult = true;
                                }

                                this.isPhoneInvaild = phoneResult;
                                break;
                            default:
                                break;
                        }
                    }
                }
                console.log('infoStateObj', this.infoStateObj);
            },            
            handleFieldValue(payload) {
                if (this.isNameEmpty || this.hasNameIllegalCharaters || this.isCarNoInvaild || this.isPhoneInvaild) {
                    bus.$emit('passInfoStateObj', payload);
                }
                else {
                    // this.isNameEmpty = false;
                    // this.hasNameIllegalCharaters = false;
                    // this.isCarNoInvaild = false;
                    // this.isPhoneInvaild =  false;

                    this.$router.push(`/provisioning/step3`);
                }
            },
        },     
        computed: {
            infoStateObj: function() {
                return {
                    isNameEmpty: this.isNameEmpty,
                    hasNameIllegalCharaters: this.hasNameIllegalCharaters,
                    isCarNoInvaild: this.isCarNoInvaild,
                    isPhoneInvaild: this.isPhoneInvaild,
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .provisioning_btn_container {
      margin-top: 45px;
  }
</style>